// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { productCompareFlyOutStyles } from "@tps/Overrides/Components/ProductCompareFlyOut";
import IconPaginationBlockLeftInactive from "@tps/XDL/Icons/IconPaginationBlockLeftInactive";
import IconPaginationBlockRightInactive from "@tps/XDL/Icons/IconPaginationBlockRightInactive";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    size: 200,
    cssOverrides: {
        scrim: css`
            height: auto;
        `,
        drawerBody: css`
            height: auto;
            padding-block: 16px;
            row-gap: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            row-gap: 0;
                        `,
                    ],
                    "max",
                )}
        `,
        drawerTitle: css`
            background: ${color("common.accent")};
            color: ${color("common.accentContrast")};
            padding: 0;
            min-height: unset;
        `,
        drawerContent: css`
            overflow-y: visible;
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    css: css`
        position: absolute;
        right: 20px;
        top: 0;
        &:hover {
            ${IconWrapper} {
                color: ${color("danger")};
            }
        }
    `,
};

productCompareFlyOutStyles.headerGridContainer = {
    gap: 0,
    css: css`
        margin: 0 auto;
        padding-inline: 16px;
    `,
    offsetCss: css`
        align-items: center;
        row-gap: 16px;
    `
};

productCompareFlyOutStyles.headerTitleGridItem = {
    width: [12, 6, 6, 6, 6],
    align: "middle",
};

productCompareFlyOutStyles.headerTitleText = {
    variant: "h4",
    css: css`
        margin: 0;
    `,
};

productCompareFlyOutStyles.headerActionsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        justify-content: flex-end;
        gap: 10px;
    `,
};

productCompareFlyOutStyles.headerRemoveAllButton = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex: 1;
                    `,
                ],
                "max",
            )}
    `,
    variant: "secondary",
};

productCompareFlyOutStyles.headerCompareButton = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex: 1;
                    `,
                ],
                "max",
            )}
    `,
};

productCompareFlyOutStyles.carousel = {
    titleText: {
        css: css`
            display: none;
        `,
    },
    prevIconProps: {
            src: IconPaginationBlockLeftInactive,
            css: css`
            &&& {
                color: ${color("primary.main")};
                &:hover {
                    opacity: 1;
                    color: ${color("common.ui8")};
                }
            }
        `,
    },
    prevArrowButton: {
        css: css`
            border: 0;
            padding: 0;
            &, &:hover, &:disabled {
                background: none;
            }
            &:focus {
                outline: none;
            }
            &:disabled {
                ${IconWrapper} {
                    pointer-events: none;
                    color: ${color("primary")};
                    opacity: 0.33;
                }
            }
        `,
    },
    nextArrowButton: {
        css: css`
            border: 0;
            padding: 0;
            &, &:hover, &:disabled, &:focus {
                background: none;
                outline: none;
            }
            &:disabled {
                ${IconWrapper} {
                    pointer-events: none;
                    color: ${color("primary")};
                    opacity: 0.33;
                }
            }
        `,
    },
    nextIconProps: {
        src: IconPaginationBlockRightInactive,
        css: css`
            &&& {
                color: ${color("primary.main")};
                &:hover {
                    opacity: 1;
                    color: ${color("common.ui8")};
                }
            }
        `,
    },
};
